import { TABS } from "../const";

export const getTabList = () => {
  const tabs = [TABS.SUBMITTED_BILLS, TABS.MANAGE_DRAFT, TABS.MANAGE_RECIPIENTS];
  return tabs;
};
